<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import AppButton from '../../primitives/AppButton/AppButton.vue'
import RaldoMark from '../../primitives/RaldoMark/RaldoMark.vue'
import { useChatDock, CHAT_DOCK_KEYBOARD_SHORTCUT } from '../AppChatPanel/useChatDock'
import { vCoach } from '../../tour/v-coach'

const { openDock } = useChatDock()
const { t } = useI18n()
</script>

<template>
  <AppButton
    v-coach="'shell.dockButton'"
    class="motion-safe:animate-fade-in"
    variant="glass"
    size="md"
    elevated
    :label="t('chat.dock.askRaldo')"
    :shortcut="CHAT_DOCK_KEYBOARD_SHORTCUT"
    @click="openDock"
  >
    <template #icon>
      <RaldoMark size="icon" decorative />
    </template>
  </AppButton>
</template>
